(function () {
  if (typeof window === 'undefined') return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window.gsap) {
      console.warn('[mf-gsap] gsap failed to load');
      return;
    }

    var hasScrollTrigger = !!window.ScrollTrigger;
    if (hasScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    } else {
      console.warn('[mf-gsap] ScrollTrigger failed to load');
    }

    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    window.mfReducedMotion = reduceQuery.matches;
    if (reduceQuery.addEventListener) {
      reduceQuery.addEventListener('change', function (e) {
        window.mfReducedMotion = e.matches;
      });
    }

    // Vanilla stand-in for the React useGSAP hook: scopes an animation to a
    // DOM node via gsap.context() and hands back that context so callers can
    // .revert() it for cleanup, the same guarantee useGSAP gives on unmount.
    // When the visitor prefers reduced motion, the setup function is called
    // once with { reduced: true } so it can jump straight to the end state
    // instead of animating, and no GSAP tween/ScrollTrigger is created.
    window.mfGSAP = function (scope, setup) {
      if (typeof setup !== 'function') return { revert: function () {} };

      if (window.mfReducedMotion) {
        setup({ reduced: true });
        return { revert: function () {} };
      }

      return gsap.context(function () {
        setup({ reduced: false });
      }, scope || document.body);
    };

    console.log(
      '[mf-gsap] ready — gsap ' + gsap.version +
      ', ScrollTrigger ' + (hasScrollTrigger ? 'registered' : 'missing') +
      ', reduced motion: ' + window.mfReducedMotion
    );
  });
})();
